import { productTaxonomyRouteCatalog } from './renames';
import type { ProductTaxonomyRouteTemplate, ProductTaxonomyVariant } from './types';

export type { ProductTaxonomyRouteTemplate } from './types';

export type ProductTaxonomyRouteKey = keyof typeof productTaxonomyRouteCatalog;

export function resolveProductTaxonomyRoute(
  key: ProductTaxonomyRouteKey,
  variant: ProductTaxonomyVariant,
): ProductTaxonomyRouteTemplate {
  return productTaxonomyRouteCatalog[key][variant];
}
